import produce from 'immer'

import { Types } from './actions'

const INITIAL_STATE = {
  show: false
}

export default function headerReducers (state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case Types.showHeader: {
        draft.show = action.payload.show || false
        break
      }

      default:
    }
  })
}
